<template>
    <div class="home">
        <h1>Administration Laufnachweise</h1>
        <RunsInvalidation :page="parseInt(page) || 1" />
    </div>
</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import RunsInvalidation from '@/components/admin/RunsInvalidation';

    export default {
        name: 'AdminRuns',
        props: {
            page: String
        },
        components: {
            RunsInvalidation,
        },
        methods: {

        },
    }
</script>

